module.exports = __webpack_public_path__ + "static/media/cleanvertising-black.5dfe8647.ttf";